import { Vue } from 'vue-property-decorator'
import { BaseClient } from '@/api'
import _ from 'lodash'
import BaseEditor from '@/views/BaseEditor'
import * as FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
import { parseTime } from '@/utils'

export default class extends Vue {
  protected client: BaseClient
  protected list = []
  protected listLoading = false
  protected dialogFormVisible = false
  protected total = 0
  protected pageSizes= [10, 20, 30, 50, 100, 500, 1000, 5000]
  protected listQuery: any = {
    filter: {
      fields: {
        id: true,
        name: true,
        description: true,
        createdAt: true
      },
      limit: 10,
      page: 1,
      skip: 0,
      order: ['createdAt']
    }
  }

  public constructor() {
    super()
    this.client = new BaseClient('')
  }

  async created() {
    await this.getList()
  }

  protected async getList() {
    this.listLoading = true
    const t = this.generateQuery()
    this.list = await this.client.fetch(t)
    this.total = (await this.client.count(t.filter)).count
    this.listLoading = false
  }

  protected generateQuery():any {
    return _.cloneDeep(this.listQuery)
  }

  protected async handleFilter() {
    this.getList()
  }

  protected async handleSizeChange(val:number) {
    this.listQuery.filter.limit = val
    this.listQuery.filter.skip =
        this.listQuery.filter.limit * (this.listQuery.filter.page - 1)
    this.getList()
  }

  protected async handleCurrentChange(val:number) {
    this.listQuery.filter.page = val
    this.listQuery.filter.skip =
        this.listQuery.filter.limit * (this.listQuery.filter.page - 1)
    this.getList()
  }

  protected async handleCreate() {
    this.dialogFormVisible = true
    setTimeout(() => {
      if (this.$refs['dataEditor']) {
        const editor = this.$refs['dataEditor'] as BaseEditor
        editor.reset()
        editor.getData()
      }
    }, 500)
  }

  protected async handleUpdate(row: any) {
    this.dialogFormVisible = true
    setTimeout(() => {
      if (this.$refs['dataEditor']) {
        const editor = this.$refs['dataEditor'] as BaseEditor
        editor.reset()
        editor.getData(row.id)
      }
    }, 500)
  }

  protected async handleDelete(row: any) {
    try {
      const r = await this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'el-button--danger',
        type: 'warning'
      })
      if (r === 'confirm') {
        await this.client.remove(row.id)
        await this.getList()
        this.dialogFormVisible = false
        this.$notify({
          title: '成功',
          message: '删除成功',
          type: 'success',
          duration: 2000
        })
      } else {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      }
    } catch (e) {
      this.$message({
        type: 'info',
        message: '已取消删除'
      })
    }
  }

  protected async saveData() {
    const editor = this.$refs['dataEditor'] as BaseEditor
    if (await editor.saveData()) {
      this.dialogFormVisible = false
      this.getList()
    }
  }

  protected async exportXlsx(data:any, fileName:any = 'data') {
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data)
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] }
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
    this.saveAsExcelFile(excelBuffer, fileName)
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + '.xlsx')
  }

  protected formatJson(filterVal :any, jsonData:any) {
    const data = jsonData.map((v:any) => filterVal.map((j:any) => {
      return v[j]
    }))
    return data
  }

  protected parseTime(time:any, cFormat:string = '{y}-{m}-{d} {h}:{i}:{s}') {
    return parseTime(time, cFormat)
  }
}
